<template>
  <div class="teacher-calendar navigation-top-app">
    <navigation-top-app
      :app="app"
      :back="back"
    >
      <template v-slot:center>
        <div id="navigation-center">
          <template v-if="step === 1">
            {{ app.strings.practice.create.select_student }}
          </template>
          <template v-else>
            {{ app.strings.practice.create.config_class }}
          </template>
        </div>
      </template>
    </navigation-top-app>
    <transition name="fade">
      <div id="teacher-create-content" :class="{narrow: step > 1}" v-if="show">
        <template v-if="loading === false && step === 1">
          <student-list
            :app="app"
            :students="student.data"
            :search="true"
            @onSelect="(student) => {
              studentSelect(student)
            }"></student-list>
        </template>
        <template v-if="loading === false && step >= 2">
          <div class="student-data" :class="{clickable: step === 6}" v-on:click="step === 6 && updateStep(1)">
            <img src="@/assets/images/avatar.svg" />
            <div>
              {{ practice.form.student.first_name }} {{ practice.form.student.last_name_1 }} {{ practice.form.student.last_name_2 }}
            </div>
            <div>
              {{ practice.form.student.code }}
            </div>
            <template v-if="step >= 4 && practice.form.id === 0">
              <div v-if="balance >= 0">
                {{ app.strings.practice.create.balance_remain_1 }} <b>{{ balance }}</b> {{ app.strings.practice.create.balance_remain_2 }}
              </div>
              <div v-else>
                {{ app.strings.practice.create.balance_remain_3 }} <b>{{ balance * -1 }}</b> {{ app.strings.practice.create.balance_remain_2 }}
              </div>
            </template>
          </div>
        </template>
        <template v-if="loading === false && step >= 2 && step < 5">
          <div class="practice-quantiy">
            <div class="form-label">
              {{ app.strings.practice.create.select_quantity }}
            </div>
            <div class="choice" :class="{open: selectors.quantity}">
              <div class="choice-head" v-on:click="selectors.quantity = !selectors.quantity">
                <span v-if="practice.form.quantity > 0" class="choice-text">
                  <span>{{ app.strings.practice.create.quantity[practice.form.quantity-1] }}</span>
                </span>
                <span v-else class="choice-placeholder">{{ app.strings.practice.create.click_indicator }}</span>
              </div>
              <div v-if="selectors.quantity" class="choice-list">
                <div v-for="i in maxQuantity" class="choice-row" v-on:click="practice.form.quantity = i; updateStep(3);" v-bind:key="i">
                  <span class="choice-text">
                    <span>{{ app.strings.practice.create.quantity[i-1] }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="loading === false && step >= 3 && step < 5">
          <div class="practice-type">
            <div class="form-label">
              {{ app.strings.practice.create.select_type }}
            </div>
            <div class="choice" :class="{open: selectors.type}">
              <div class="choice-head" v-on:click="selectors.type = !selectors.type">
                <template v-if="practice.form.type.id !== 0">
                  <b class="choice-badge">{{ practice.form.type.license }}</b>
                  <span class="choice-text">
                    <span>{{ practice.form.type.name }}</span>
                    <small>{{ practice.form.type.time }} min · {{ practice.form.type.price }} €</small>
                  </span>
                </template>
                <span v-else class="choice-placeholder">{{ app.strings.practice.create.click_indicator }}</span>
              </div>
              <div v-if="selectors.type" class="choice-list">
                <div v-for="type in types.data" class="choice-row" v-on:click="practice.form.type = type; updateStep(4);" v-bind:key="type.id">
                  <b class="choice-badge">{{ type.license }}</b>
                  <span class="choice-text">
                    <span>{{ type.name }}</span>
                    <small>{{ type.time }} min · {{ type.price }} €</small>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="loading === false && step >= 4 && step < 5">
          <div class="practice-vehicle">
            <div class="form-label">
              {{ app.strings.practice.create.select_vehicle }}
            </div>
            <div class="choice" :class="{open: selectors.vehicle}">
              <div class="choice-head" v-on:click="selectors.vehicle = !selectors.vehicle">
                <span v-if="practice.form.vehicle.id !== 0" class="choice-text">
                  <span>{{ practice.form.vehicle.name }}</span>
                </span>
                <span v-else class="choice-placeholder">{{ app.strings.practice.create.click_indicator }}</span>
              </div>
              <!-- A vehicle not for the license or the use of the type is shown
                   disabled, with the reason (Miguel's «pruebas de agenda», 4). -->
              <div v-if="selectors.vehicle" class="choice-list">
                <div v-for="item in vehiclesSorted" class="choice-row" :class="{'vehicle-unfit': practiceVehicleUnfit(app.strings, item, practice.form.type, vehicle.teacher) !== ''}" v-on:click="vehicleSelected(item)" v-bind:key="item.code">
                  <span class="choice-text">
                    <span>{{ item.name }}</span>
                    <small v-if="practiceVehicleUnfit(app.strings, item, practice.form.type, vehicle.teacher) !== ''">{{ practiceVehicleUnfit(app.strings, item, practice.form.type, vehicle.teacher) }}</small>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="loading === false && step === 5">
          <div class="form-label">
            {{ app.strings.practice.create.select_day }}
          </div>

          <calendar-small
            id="calendar"
            :app="app"
            :hilighted="{
              day: this.calendar.day,
              month: this.calendar.month,
              year: this.calendar.year
            }"
            @onDayClick="(day) => {
              this.calendar.day = day
            }"
            @onMonthMove="(month) => {
              this.calendar.month = month
              this.calendarKeepDay()
            }"
            @onYearMove="(year) => {
              this.calendar.year = year
              this.calendarKeepDay()
            }"
          ></calendar-small>

          <div class="form-label">
            {{ app.strings.practice.create.select_time }}
          </div>

          <div class="text-center">
            <vue-timepicker
              v-model="practice.form.time"
              drop-direction="auto"
              :minute-interval="15"
              @change="timeSelected()" hide-clear-button></vue-timepicker>
          </div>
        </template>
        <template v-if="loading === false && step === 6">
          <div class="practice-resume">
            <div class="practice-resume-item" v-on:click="step = 4">
              <div class="practice-resume-item-price">
                <div>
                  {{ practice.form.type.price }}€
                </div>
              </div>
              <div>
                {{ practice.form.type.name }} - {{ practice.form.type.time }} {{ app.strings.common.minutes }}
              </div>
            </div>
            <div class="practice-resume-item" v-on:click="step = 4">
              <div>
                <font-awesome-icon class="icon" :icon="['fas', 'layer-group']" />
              </div>
              <div v-if="practice.form.quantity === 1">
                {{ practice.form.quantity }} {{ app.strings.practice.create.class }}
              </div>
              <div v-else>
                {{ practice.form.quantity }} {{ app.strings.practice.create.classes }}
              </div>
            </div>
            <div class="practice-resume-item" v-on:click="step = 4">
              <div>
                <font-awesome-icon class="icon" :icon="['fas', 'car']" />
              </div>
              <div>
                {{ practice.form.vehicle.name }}
              </div>
            </div>
            <div class="practice-resume-item" v-on:click="step = 5">
              <div>
                <font-awesome-icon class="icon" :icon="['far', 'calendar-alt']" />
              </div>
              <div>
                {{ resume.date }}
              </div>
            </div>
            <div class="practice-resume-item" v-on:click="step = 5">
              <div>
                <font-awesome-icon class="icon" :icon="['far', 'clock']" />
              </div>
              <div>
                {{ resume.time }}
              </div>
            </div>
          </div>

          <div class="form-label">
            {{ app.strings.practice.start.meeting_point }}
          </div>
          <div class="meeting-options">
            <div class="meeting-option" :class="{selected: practice.form.meeting_point === 'school'}" v-on:click="practice.form.meeting_point = 'school'">
              {{ app.strings.practice.start.meeting_school }}
            </div>
            <div class="meeting-option" :class="{selected: practice.form.meeting_point === 'other'}" v-on:click="practice.form.meeting_point = 'other'">
              {{ app.strings.practice.start.meeting_other }}
            </div>
          </div>
          <input type="text" class="meeting-address w-100" maxlength="255" v-if="practice.form.meeting_point === 'other'" :placeholder="app.strings.practice.start.meeting_address" v-model="practice.form.meeting_address" />

          <div class="form-label">
            {{ app.strings.practice.create.observations }}
          </div>

          <textarea id="observations" class="h-textarea no-resize w-100 min-h-100" v-model="practice.form.observations">
          </textarea>
        </template>
        <template v-if="loading === true">
          <loader-dot :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
        </template>
        <!-- Always at the bottom of the screen, whatever the scroll. Before day
             and hour the options move on by themselves; it only shows when
             coming back from the summary with everything already chosen. -->
        <div class="bottom-action" v-if="loading === false && (step >= 5 || canContinue)">
          <button class="h-button w-100 default-2" v-if="step < 5" v-on:click="updateStep(5, true)">
            {{ app.strings.common.continue }}
          </button>
          <button class="h-button w-100 default-2" v-if="step === 5" :disabled="hour === -1 || minute === -1" v-on:click="check()">
            {{ app.strings.practice.create.check }}
          </button>
          <button class="h-button w-100 default-2" v-if="step === 6" v-on:click="save()">
            {{ app.strings.common.save }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app-teacher-practice-create-view',
  components: {
  },
  data () {
    return {
      preselected: '',
      show: false,
      step: 1,
      maxQuantity: 3,
      practice: {
        loading: false,
        form: {
          id: 0,
          student: {

          },
          quantity: 0,
          type: {
            id: 0,
            name: '',
            price: 0,
            time: 0
          },
          vehicle: {
            id: 0,
            name: ''
          },
          time: '',
          meeting_point: 'school',
          meeting_address: '',
          observations: ''
        }
      },
      teacher: {
        loading: false
      },
      student: {
        loading: false,
        data: []
      },
      types: {
        loading: false,
        data: []
      },
      vehicle:{
        loading: false,
        data: [],
        // With the setup required, his vehicles for each license (null: any).
        teacher: null
      },
      calendar: {
        day: 0,
        month: 0,
        year: 0
      },
      selectors: {
        quantity: false,
        type: false,
        vehicle: false
      },
      checked: {
        student: false,
        teacher: false,
        vehicle: false
      },
      allowed: {
        student: false,
        teacher: false,
        vehicle: false
      }
    }
  },
  computed: {
    // The ones that can be picked first; the rest below, with their reason.
    vehiclesSorted () {
      let unfit = (item) => this.practiceVehicleUnfit(this.app.strings, item, this.practice.form.type, this.vehicle.teacher) !== ''
      return [...this.vehicle.data].sort((a, b) => unfit(a) - unfit(b))
    },
    canContinue () {
      return this.step >= 2 && this.step <= 4 && this.practice.form.quantity > 0 &&
        this.practice.form.type.id !== 0 && this.practice.form.vehicle.id !== 0 && this.canKeepVehicle()
    },
    loading () {
      if (this.student.loading) {
        return true
      }

      if (this.types.loading) {
        return true
      }

      if (this.vehicle.loading) {
        return true
      }

      if (this.practice.loading) {
        return true
      }

      return false
    },
    hour () {
      let time = this.practice.form.time.split(':')

      if (time.length === 0) {
        return -1
      }

      let hour = time[0]

      if (isNaN(hour)) {
        return -1
      }

      return parseInt(hour)
    },
    minute () {
      let time = this.practice.form.time.split(':')

      if (time.length === 0) {
        return -1
      }

      let minute = time[1]

      if (isNaN(minute)) {
        return -1
      }

      return parseInt(minute)
    },
    resume () {
      let date = this.calendar.day + ' ' + this.app.strings.common.of + ' ' + this.app.strings.common.months[this.calendar.month] + ' ' + this.calendar.year

      let time = ''

      if (this.hour !== -1 && this.minute !== -1) {
        let start = this.practice.form.time

        let minutes = (this.hour * 60) + this.minute + parseInt(parseInt(this.practice.form.type.time) * parseInt(this.practice.form.quantity))

        let hours = (minutes / 60)
        let hourEnd = Math.floor(hours)
        minutes = (hours - hourEnd) * 60
        let minuteEnd = Math.round(minutes)

        let end = (hourEnd < 10 ? '0' : '') + hourEnd + ':' + (minuteEnd < 10 ? '0' : '') + minuteEnd

        time = this.app.strings.common.of + ' ' + start + ' ' + this.app.strings.common.to + ' ' + end + ' ' + this.app.strings.common.hours
      }

      return {
        date: date,
        time: time
      }
    },
    balance () {
      if (this.step >= 4) {
        let balance = this.practice.form.student.bag.find(b => b.practice_type === this.practice.form.type.id)
        if (balance !== undefined) {
          return balance.balance
        }
      }

      return 0
    }
  },
  props: [
    'app'
  ],
  mounted () {
    let id = this.$route.query.id

    if (id !== undefined && id !== null) {
      id = parseInt(id)
    } else {
      id = 0
    }

    if (id !== 0) {
      this.practice.form.id = id
      this.step = 6
    }

    // Coming from a student's screen the first step is already answered.
    if (id === 0 && this.$route.query.student) {
      this.preselected = this.$route.query.student
    }

    this.show = !this.preselected

    this.practiceRead()
    this.studentReadAll()
    this.typesRead()
    this.vehicleReadAll()
  },
  methods: {
    // Where the wizard ends, forwards or backwards.
    leave () {
      if (this.preselected) {
        this.$router.push({name: 'app.student.profile', params: {code: this.preselected}, query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
      } else {
        this.$router.push({name: 'app.practice.calendar', query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
      }
    },
    back () {
      if (this.step === 1 || (this.step === 2 && this.preselected)) {
        this.leave()
      } else if (this.step === 2) {
        this.practice.form.quantity = 0
        this.updateStep(1, true)
      } else if (this.step === 3) {
        this.practice.form.quantity = 0
        this.updateStep(2)
      } else if (this.step === 4) {
        // The form holds the very objects of the lists: a new empty one, or the
        // option picked would stay with id 0 and could not be chosen again.
        this.practice.form.type = {id: 0, name: '', price: 0, time: 0}
        this.updateStep(3)
      } else if (this.step === 5) {
        this.practice.form.vehicle = {id: 0, name: ''}
        this.updateStep(4, true)
      } else if (this.step === 6) {
        this.updateStep(5, true)
      }
    },
    // A vehicle not for the license or the use of the type is not picked.
    // The chosen day may not exist in the new month (the 31st, in November).
    calendarKeepDay () {
      let last = this.daysInMonth(this.calendar.month, this.calendar.year)
      if (this.calendar.day > last) {
        this.calendar.day = last
      }
    },
    vehicleSelected (vehicle) {
      if (this.practiceVehicleUnfit(this.app.strings, vehicle, this.practice.form.type, this.vehicle.teacher) !== '') {
        return
      }
      this.practice.form.vehicle = vehicle
      this.updateStep(5, true)
    },
    updateStep (step, animation) {
      // The next choice comes open: picking one option is enough to go on.
      this.selectors.quantity = step === 2 && this.practice.form.quantity === 0
      this.selectors.type = step === 3
      this.selectors.vehicle = step === 4 && (this.practice.form.vehicle.id === 0 || !this.canKeepVehicle())
      if (animation === true) {
        this.show = false
        this.step = step
        setTimeout(() => {
          this.show = true
        }, 500)
      } else {
        this.step = step
      }
    },
    canKeepVehicle () {
      return this.practiceVehicleUnfit(this.app.strings, this.practice.form.vehicle, this.practice.form.type, this.vehicle.teacher) === ''
    },
    practiceRead () {
      if (this.practice.form.id === 0) {
        return
      }

      if (this.practice.loading) {
        return
      }

      this.practice.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.read.one + this.practice.form.id,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            let data = response.body.data.practice

            this.practice.form.student = response.body.data.student

            this.practice.form.quantity = 1
            // The type of the class by its id, never by duration and price:
            // two types can share them, and another type would be a type
            // change that takes a class from the balance (A1 of Miguel).
            this.practice.form.type.id = data.type_id
            this.practice.form.type.price = data.price
            this.practice.form.type.time = data.time

            for (let i in this.types.data) {
              let ttype = this.types.data[i]
              if (ttype.id === this.practice.form.type.id) {
                this.practice.form.type = ttype
                break
              }
            }

            this.practice.form.vehicle = response.body.data.vehicle

            this.practice.form.observations = data.observations
            this.practice.form.meeting_point = data.meeting_point || 'school'
            this.practice.form.meeting_address = data.meeting_address || ''

            let date = new Date(data.date)

            this.calendar.day = date.getDate()
            this.calendar.month = date.getMonth()
            this.calendar.year = date.getFullYear()

            this.practice.form.time = (data.hour < 10 ? '0' : '') + data.hour + ':' + (data.minute < 10 ? '0' : '') + data.minute
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-read-one', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.practice.loading = false
      }, () => {
        this.practice.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    practiceDateUpdated () {

    },
    studentReadAll () {
      if (this.student.loading) {
        return
      }

      this.student.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.student.read.all + '?teacher=' + this.app.user.code,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.student.data = response.body.data.students
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'student-search', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.student.loading = false
        if (this.preselected) {
          this.studentRead(this.preselected)
        }
      }, () => {
        this.student.loading = false
        this.show = true
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    studentRead (code) {
      if (this.student.loading) {
        return
      }

      this.student.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.student.read.one + code,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.practice.form.student = response.body.data.student
            if (this.show) {
              this.updateStep(2, true)
            } else {
              this.updateStep(2)
              this.show = true
            }
          } else {
            this.show = true
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'student-search', response.body.error)
            }
          }
        } else {
          this.show = true
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.student.loading = false
      }, () => {
        this.student.loading = false
        this.show = true
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    studentSelect (student) {
      this.studentRead(student.code)
    },
    typesRead () {
      if (this.types.loading) {
        return
      }

      this.types.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.type.read.all,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.types.data = response.body.data.types

            for (let i in this.types.data) {
              let ttype = this.types.data[i]
              if (this.practice.form.type.id !== undefined && ttype.id === this.practice.form.type.id) {
                this.practice.form.type = ttype
                break
              }
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-type-read-all', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.types.loading = false
      }, () => {
        this.types.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    vehicleReadAll (vehicle, autoselectFilter) {
      if (this.vehicle.loading) {
        return
      }

      this.vehicle.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.vehicle.read.all,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.vehicle.data = response.body.data.vehicles
            this.vehicle.teacher = response.body.data.teacher_vehicles || null
            if (autoselectFilter === true) {
              for (let i in this.vehicle.data) {
                if (this.vehicle.data[i].code === vehicle) {
                  this.vehicle.filter = this.vehicle.data[i]
                }
              }
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'vehicle-search', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.vehicle.loading = false
      }, () => {
        this.vehicle.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    timeSelected () {

    },
    check () {
      this.checkTarget('student', this.practice.form.student.code)
      this.checkTarget('teacher', this.app.user.code)
      this.checkTarget('vehicle', this.practice.form.vehicle.code)
    },
    checkTarget (target, code) {
      if (target === 'student') {
        if (this.student.loading) {
          return
        }

        this.student.loading = true
      }

      if (target === 'teacher') {
        if (this.teacher.loading) {
          return
        }

        this.teacher.loading = true
      }

      if (target === 'vehicle') {
        if (this.vehicle.loading) {
          return
        }

        this.vehicle.loading = true
      }

      this.allowed[target] = false

      let date = this.calendar.year + '-' + ((this.calendar.month + 1) < 10 ? '0' : '') + (this.calendar.month + 1) + '-' + (this.calendar.day < 10 ? '0' : '') + this.calendar.day

      let time = this.practice.form.type.time * this.practice.form.quantity

      this.$http.post(
        this.app.url.api + this.app.endpoints.practice.check,
        {
          id: this.practice.form.id,
          target: target,
          code: code,
          date: date,
          hour: parseInt(this.practice.form.time.split(':')[0]),
          minute: parseInt(this.practice.form.time.split(':')[1]),
          time: parseInt(time)
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.allowed[target] = !response.body.exists
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'event-check', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        if (target === 'student') {
          this.student.loading = false
        } else if (target === 'teacher') {
          this.teacher.loading = false
        } else if (target === 'vehicle') {
          this.vehicle.loading = false
        }
        this.checkend(target)
      }, () => {
        if (target === 'student') {
          this.student.loading = false
        } else if (target === 'teacher') {
          this.teacher.loading = false
        } else if (target === 'vehicle') {
          this.vehicle.loading = false
        }
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
        this.checkend(target)
      })
    },
    checkend (target) {
      this.checked[target] = true
      if (this.checked.student === true && this.checked.teacher === true && this.checked.vehicle === true) {
        this.checked.student = false
        this.checked.teacher = false
        this.checked.vehicle = false

        if (this.allowed.student === true && this.allowed.teacher === true && this.allowed.vehicle === true) {
          this.updateStep(6, true)
        } else {
          let title = ''
          let content = ''

          if (this.allowed.student === false) {
            title = this.app.strings.practice.create.check_error.student.title
            content = this.app.strings.practice.create.check_error.student.content
          } else if (this.allowed.teacher === false) {
            title = this.app.strings.practice.create.check_error.teacher.title
            content = this.app.strings.practice.create.check_error.teacher.content
          } else if (this.allowed.vehicle === false) {
            title = this.app.strings.practice.create.check_error.vehicle.title
            content = this.app.strings.practice.create.check_error.vehicle.content
          }

          this.$swal({
            title: title,
            text: content,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.app.strings.common.confirm
          })
        }
      }
    },
    save (index, confirm) {
      if (index === undefined) {
        index = 0
      }

      if (this.practice.loading) {
        return
      }

      if (index === 0 && this.practice.form.meeting_point === 'other' && this.practice.form.meeting_address.trim() === '') {
        this.showError(this.app.strings, 'practice-create', this.app.strings.practice.start.meeting_address_empty)
        return
      }

      if (index === parseInt(this.practice.form.quantity)) {
        setTimeout(() => {
          this.leave()
        }, 1000)
        return
      }

      let date = this.calendar.year + '-' + ((this.calendar.month + 1) < 10 ? '0' : '') + (this.calendar.month + 1) + '-' + (this.calendar.day < 10 ? '0' : '') + this.calendar.day

      let hour = parseInt(this.practice.form.time.split(':')[0])
      let minute = parseInt(this.practice.form.time.split(':')[1])

      if (index > 0) {
        let minutes = (parseInt(this.practice.form.time.split(':')[0]) * 60) + parseInt(this.practice.form.time.split(':')[1]) + (parseInt(this.practice.form.type.time) * parseInt(index))

        let hours = (minutes / 60)
        hour = Math.floor(hours)
        minutes = (hours - hour) * 60
        minute = Math.round(minutes)
      }

      if (this.practice.form.id === 0) {
        if (this.balance - parseInt(this.practice.form.quantity) < 0 && this.app.user.config.practice.balance === 0) {
          this.$swal({
            title: this.app.strings.practice.create.balance_negative_prohibit.title,
            text: this.app.strings.practice.create.balance_negative_prohibit.content,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.app.strings.common.confirm
          })
          return
        }

        if (confirm === undefined && this.balance - parseInt(this.practice.form.quantity) < 0) {
          this.$swal({
            title: this.app.strings.practice.create.balance_negative.title,
            text: this.app.strings.practice.create.balance_negative.content,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: this.app.strings.common.cancel,
            confirmButtonText: this.app.strings.common.confirm
          }).then((result) => {
            if (result.value) {
              this.save(index, true)
            }
          })
          return
        }
      }

      this.practice.loading = true

      this.$http.post(
        this.app.url.api + this.app.endpoints.practice.create,
        {
          practice: JSON.stringify({
            id: this.practice.form.id,
            license: this.practice.form.type.license,
            circuit: this.practice.form.type.circuit,
            exam: this.practice.form.type.exam,
            student: this.practice.form.student.code,
            teacher: this.app.user.code,
            vehicle: this.practice.form.vehicle.code,
            date: date,
            hour: hour,
            minute: minute,
            time: parseInt(this.practice.form.type.time),
            price: parseFloat(this.practice.form.type.price * 1.0),
            color: this.practice.form.student.center.color,
            type_id: parseInt(this.practice.form.type.id),
            observations: this.practice.form.observations,
            meeting_point: this.practice.form.meeting_point,
            meeting_address: this.practice.form.meeting_point === 'other' ? this.practice.form.meeting_address.trim() : ''
          })
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.practice.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            index++
            this.save(index, confirm)
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-create', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.practice.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";
@import "@/assets/styles/mobile-app.scss";

#teacher-create-content {
  width: 100%;
  height: 100%;
  padding: 60px 0 96px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}

// From tablet up the form keeps a readable width, centered. The list of
// students of the first step takes the whole screen.
@media (min-width: 768px) {
  #teacher-create-content.narrow {
    padding-left: #{"max(0px, calc((100% - 640px) / 2))"} !important;
    padding-right: #{"max(0px, calc((100% - 640px) / 2))"} !important;
  }
}

@media (min-width: 1024px) {
  #teacher-create-content {
    padding-top: 84px;
  }
}

// This screen's scroll keeps the top bar's room as padding, and a sticky
// element counts from there.
#teacher-create-content ::v-deep .student-search {
  top: -12px;
}

@media (min-width: 1024px) {
  #teacher-create-content ::v-deep .student-search {
    top: -16px;
  }
}

.student-data {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 12px;
  align-items: center;
  padding: 10px 12px;
  box-sizing: border-box;
  border: 1px solid var(--va-color-border, #e8edf3);
  border-radius: 14px;
  background-color: var(--va-color-surface, #fff);
}

.student-data > img {
  grid-row: 1 / span 3;
  width: 56px;
  height: 56px;
}

.student-data > div {
  grid-column: 2;
  color: $text-color-1;
  font-size: 13px;
  line-height: 18px;
}

.student-data > div:nth-of-type(1) {
  font-size: 15px;
  font-weight: bold;
  overflow-wrap: anywhere;
}

.practice-quantiy {
  margin-top: 12px;
}

.practice-resume {
  display: flex;
  flex-direction: column;
}

.practice-resume-item {
  display: flex;
  min-height: 60px;
  padding: 10px 12px;
  box-sizing: border-box;
  margin-top: 10px;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.08);
  cursor: pointer;
}

.practice-resume-item > div {
  display: flex;
  align-items: center;
}

.practice-resume-item > div:nth-of-type(1) {
  width: 60px;
  justify-content: center;
  color: $color-primary-1;
}

.practice-resume-item > div:nth-of-type(1) > .icon {
  width: 40px;
  height: 40px;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  background-color: rgba(32, 113, 183, 0.1);
  color: #2071b7;
  font-size: 20px;
}

.practice-resume-item > div:nth-of-type(2) {
  flex: 1;
  padding-left: 4px;
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.practice-resume-item-price > div {
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: rgba(32, 113, 183, 0.1);
  color: #2071b7;
  font-family: 'Lexend', sans-serif;
  font-size: 13px;
  font-weight: 700;
  align-items: center;
  justify-content: center;
}

#observations {
  border: 1px solid #e8edf3;
}

.meeting-options {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.meeting-option {
  flex: 1;
  padding: 10px;
  border-radius: 12px;
  border: 2px solid #e8edf3;
  background-color: #FFFFFF;
  font-family: 'Lexend', sans-serif;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}

.meeting-option.selected {
  border-color: $color-primary-1;
  color: $color-primary-1;
}

.meeting-address {
  padding: 12px;
  margin-bottom: 12px;
  box-sizing: border-box;
}

// Rows that grow with their text: a class type's name can take two or three
// lines on a phone, and fixed rows piled them on top of each other.
.choice {
  box-sizing: border-box;
  width: 100%;
  background-color: var(--va-color-surface, #fff);
  border: 1px solid var(--va-color-border, #e8edf3);
  border-radius: 14px;
  overflow: hidden;
}

.choice-head,
.choice-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 50px;
  padding: 10px 14px;
  box-sizing: border-box;
  text-align: left;
  cursor: pointer;
}

.choice-head {
  justify-content: center;
}

.choice-placeholder {
  color: var(--va-color-primary, #2071b7);
  font-size: 15px;
  font-weight: 600;
}

.choice-list {
  border-top: 1px solid var(--va-color-border, #e8edf3);
}

.choice-row + .choice-row {
  border-top: 1px solid var(--va-color-border, #e8edf3);
}

.choice-badge {
  flex: none;
  min-width: 36px;
  padding: 4px 6px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: var(--va-color-primary-soft, rgba(32, 113, 183, 0.1));
  color: var(--va-color-primary, #2071b7);
  font-size: 13px;
  text-align: center;
}

.choice-text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  color: var(--va-color-text-primary, #1f2a37);
  font-size: 14px;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.choice-text small {
  color: var(--va-color-text-muted, #64748b);
  font-size: 12.5px;
}

.choice-row.vehicle-unfit {
  cursor: not-allowed;
}

.choice-row.vehicle-unfit .choice-text > span {
  color: #94a3b8;
}

.choice-row.vehicle-unfit small {
  color: #b45309;
}
</style>
